{
  "page_count": "z {n, plural, one{# stránky} other{# stránek}}"
}
